import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import localStorage from 'redux-persist/lib/storage';
import { StateSliceName } from 'state/StateSliceName';

export enum PhoneDisplayMode {
  Minimized = 'Minimized',
  Maximized = 'Maximized',
}

// TODO (future): Consider storing in a clinic-user map
interface PhoneState {
  displayMode: PhoneDisplayMode;
}

const initialState: PhoneState = {
  displayMode: PhoneDisplayMode.Maximized,
};

export const phoneSlice = createSlice({
  name: StateSliceName.Phone,
  initialState,
  reducers: {
    resetPhoneState: () => initialState,
    setPhoneDisplayMode: (state, action: PayloadAction<{ displayMode: PhoneDisplayMode }>) => {
      state.displayMode = action.payload.displayMode;
      return state;
    },
  },
});

export const { resetPhoneState, setPhoneDisplayMode } = phoneSlice.actions;

const persistConfig = {
  key: 'phone',
  version: 1,
  storage: localStorage,
};

export default persistReducer(persistConfig, phoneSlice.reducer);
